<script lang="ts">
  import type { ExecutiveHighlight } from '$core/report/report.types';
  import MetricTile from '../../components/MetricTile.svelte';
  import EmptyState from '../../components/EmptyState.svelte';

  export let highlights: ExecutiveHighlight[];

  type TileStatus = 'ok' | 'warning' | 'error' | 'neutral';

  function categoryToStatus(category: ExecutiveHighlight['category']): TileStatus {
    switch (category) {
      case 'score': return 'ok';
      case 'cost': return 'warning';
      case 'risk': return 'error';
      case 'rework': return 'neutral';
      case 'visibility': return 'neutral';
      default: return 'neutral';
    }
  }
</script>

<section class="executive-summary" aria-label="Resumo executivo">
  {#if highlights.length === 0}
    <EmptyState message="Sem highlights disponíveis ainda. Complete a importação." />
  {:else}
    <div class="executive-summary__grid">
      {#each highlights as highlight (highlight.code)}
        <div
          class="executive-summary__tile-wrapper executive-summary__tile-wrapper--{highlight.category}"
        >
          <MetricTile
            label={highlight.label}
            value={highlight.formattedValue}
            helper={highlight.explanation}
            status={categoryToStatus(highlight.category)}
          />
        </div>
      {/each}
    </div>
  {/if}
</section>

<style>
  .executive-summary {
    width: 100%;
  }

  .executive-summary__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-auto-rows: 1fr;
    gap: var(--ptt-space-4);
  }

  /* Uniform height: wrapper fills grid cell, tile fills wrapper, helper expands */
  .executive-summary__tile-wrapper {
    height: 100%;
  }

  .executive-summary__tile-wrapper :global(.metric-tile) {
    height: 100%;
    box-sizing: border-box;
  }

  .executive-summary__tile-wrapper :global(.metric-tile__helper) {
    flex: 1;
  }

  /* Category border-left overrides */
  .executive-summary__tile-wrapper--cost :global(.metric-tile) {
    border-left-color: var(--ptt-yellow-200);
  }

  .executive-summary__tile-wrapper--score :global(.metric-tile) {
    border-left-color: var(--ptt-purple-100);
  }

  .executive-summary__tile-wrapper--risk :global(.metric-tile) {
    border-left-color: var(--ptt-orange-100);
  }

  .executive-summary__tile-wrapper--rework :global(.metric-tile) {
    border-left-color: var(--ptt-blue-100);
  }

  .executive-summary__tile-wrapper--visibility :global(.metric-tile) {
    border-left-color: var(--ptt-gray-100);
  }

  @media (max-width: 768px) {
    .executive-summary__grid {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 480px) {
    .executive-summary__grid {
      grid-template-columns: 1fr;
    }
  }
</style>
